import {RankedSeasonTypes} from '../../GameEnums'
import {NonFunctionProperties} from '@colonist/types'
import {DurationConverter, TimeUtils} from '@colonist/utils'
import {TranslationObject} from '@colonist/i18n'

export interface SeasonTiming {
    progress: number
    monthsLeft: number
    weeksLeft: number
    daysLeft: number
    hoursLeft: number
    minutesLeft: number
}

export class RankedSeasonState {
    readonly rankedSeasonType: RankedSeasonTypes
    readonly name: TranslationObject
    readonly startDate: Date
    readonly endDate: Date

    constructor(rankedSeasonType: RankedSeasonTypes, name: TranslationObject, startDate: Date, endDate: Date) {
        this.rankedSeasonType = rankedSeasonType
        this.name = name
        this.startDate = startDate
        this.endDate = endDate
    }

    getCurrentSeasonTiming(currentTime: Date): SeasonTiming {
        const seasonTimeRemaining = this.endDate.getTime() - currentTime.getTime()
        const totalSeasonLength = this.endDate.getTime() - this.startDate.getTime()

        return {
            monthsLeft: Math.floor(seasonTimeRemaining / DurationConverter.monthsAsMilliseconds(1)),
            weeksLeft: Math.floor(seasonTimeRemaining / DurationConverter.weeksAsMilliseconds(1) % TimeUtils.WEEKS_IN_MONTH),
            daysLeft: Math.floor((seasonTimeRemaining / DurationConverter.daysAsMilliseconds(1) % TimeUtils.DAYS_IN_MONTH) % TimeUtils.DAYS_IN_WEEK),
            hoursLeft: Math.floor(seasonTimeRemaining / DurationConverter.hoursAsMilliseconds(1) % TimeUtils.HOURS_IN_DAY),
            minutesLeft: Math.floor(seasonTimeRemaining / DurationConverter.minutesAsMilliseconds(1) % TimeUtils.MINUTES_IN_HOUR),
            progress: (totalSeasonLength - seasonTimeRemaining) / totalSeasonLength,
        }
    }

    static getShowingTimeLeftUntilSeasonEndText(time: SeasonTiming): string {
        const lessThanTwoDaysLeftUntilSeasonEnd = time.monthsLeft == 0 && time.weeksLeft == 0 && time.daysLeft < 2
        const totalDaysLeft = time.daysLeft + (time.weeksLeft * 7)
        const daysInHours = totalDaysLeft * TimeUtils.HOURS_IN_DAY
        const totalHoursLeft = daysInHours + time.hoursLeft

        if(lessThanTwoDaysLeftUntilSeasonEnd) return `${totalHoursLeft}H ${time.minutesLeft}M`
        if(time.monthsLeft > 0) return `${time.monthsLeft}M ${totalDaysLeft}D`
        return `${totalDaysLeft}D`
    }

    static deserialize(data: NonFunctionProperties<RankedSeasonState>): RankedSeasonState {
        (data.startDate as any) = new Date(data.startDate);
        (data.endDate as any) = new Date(data.endDate)

        /* eslint-disable @typescript-eslint/ban-ts-comment */
        // @ts-ignore
        const newInstance = Object.assign(new RankedSeasonState(), data)

        return newInstance
    }
}
